import { KEYS, kvDel, kvGet, kvSet } from "../lib/idb";

// All Telegram secrets live ONLY in the browser (IndexedDB). Never sent to the server.
export const sessionStore = {
  getSession: () => kvGet<string>(KEYS.session),
  putSession: (s: string) => kvSet(KEYS.session, s),
  clearSession: () => kvDel(KEYS.session),

  getApiId: () => kvGet<number>(KEYS.apiId),
  getApiHash: () => kvGet<string>(KEYS.apiHash),
  putCreds: async (apiId: number, apiHash: string) => {
    await kvSet(KEYS.apiId, apiId);
    await kvSet(KEYS.apiHash, apiHash);
  },

  getProxyEnabled: async () => (await kvGet<boolean>(KEYS.proxyEnabled)) ?? false,
  setProxyEnabled: (v: boolean) => kvSet(KEYS.proxyEnabled, v),

  getCooldownUntil: async () => (await kvGet<number>(KEYS.cooldownUntil)) ?? 0,
  setCooldownUntil: (ts: number) => kvSet(KEYS.cooldownUntil, ts),

  async clearAll() {
    await kvDel(KEYS.session);
    await kvDel(KEYS.apiId);
    await kvDel(KEYS.apiHash);
    await kvDel(KEYS.cooldownUntil);
  },
};
